module.exports = __webpack_public_path__ + "img/bg-grid-card.14ab03e3.svg";